export default {
    ToggleDisplayLayer: 'toggle-display-layout',
    SelectDisplayBasemap: 'select-base-map',
    AddAttachedTiffLayer: 'add-attached-tiff-layer',
    DeleteLayer: 'delete-layer',
}